module.exports = __webpack_public_path__ + "media/assets/faria_products/DPPRO-321a8d6ac55ec1838affe5eb76a10c835380abaa4bc83deac6abb953433a2c62.png";